var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorksIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 47,
    viewBox: "0 0 84 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5143 34.0137L61.468 9.58403L52.5728 19.4406L57.1727 24.5381C58.8759 26.4264 55.9369 28.9509 54.2372 27.0627L30.4556 0.720703L0.40625 34.0132V41.1442C0.40625 44.3016 3.05848 46.8918 6.29147 46.8918H77.6256C80.8586 46.8918 83.5108 44.3016 83.5108 41.1442L83.5143 34.0137Z",
    fill: "#EF6F6F",
    fillOpacity: 0.17
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorksIcon2);
export default __webpack_public_path__ + "static/media/works_icon2.8aea9c0e2d28c8ce54f03e7e536e8b31.svg";
export { ForwardRef as ReactComponent };